import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/print.svg';

export const IconPrint: IconComponent = props => <Icon {...props} src={src} />;
